import React from 'react'

import arrow from './../../UI/general/Icon_Show-Hide_Thin.svg'

interface Props {
  handleCloseCarStudio: () => void
  openScene: boolean
}

interface State {} 

class ExitBtnMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {

    }
  }

  render(): React.ReactNode {
      return(
        <div className={'exit-btn'} style={{ animation: this.props.openScene ? '.8s moveDown ease-in-out forwards':'none' }} onClick={() => {this.props.handleCloseCarStudio()}}>
          <img className='exit-btn-img' src={arrow} alt='' style={{ transform: 'rotate(0deg)' }}/>
          <div className='exit-btn-text'>Catálogo</div>
        </div>
      )
  }
}

export default ExitBtnMobile